import * as Yup from 'yup';
import { getEmailValidator } from '../../../common/utils/getEmailValidator';
import { getLoginPasswordValidator } from '../../../common/utils/getPasswordValidator';

export const loginValidationSchema = Yup.object().shape({
	email: getEmailValidator(),
	password: getLoginPasswordValidator()
});
